"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppointmentErrors = void 0;
const react_1 = require("react");
const useAppointmentErrors = (errors, path) => {
    const [visitDateError, setVisitDateError] = (0, react_1.useState)();
    const [visitStartTimeError, setVisitStartTimeError] = (0, react_1.useState)();
    const [visitEndTimeError, setVisitEndTimeError] = (0, react_1.useState)();
    const [extraError, setExtraError] = (0, react_1.useState)();
    const extractErrorMessages = (pathKey) => {
        var _a;
        return ((_a = errors === null || errors === void 0 ? void 0 : errors.find((error) => error.instancePath === `/${path}/${pathKey}` && error.message)) === null || _a === void 0 ? void 0 : _a.message) || undefined;
    };
    const getAppointmentError = (errors, field, defaultMessage, keyword) => {
        const error = errors.find(error => {
            var _a;
            return ((_a = error.params) === null || _a === void 0 ? void 0 : _a.missingProperty) === field ||
                (keyword && error.keyword === keyword);
        });
        return error ? error.message : defaultMessage;
    };
    const getOtherErrors = (field) => {
        const error = errors.find(error => { var _a; return ((_a = error.params) === null || _a === void 0 ? void 0 : _a.missingProperty) === field; });
        return error && "is a required property";
    };
    (0, react_1.useEffect)(() => {
        if (errors && errors.length > 0) {
            const visitDateError = extractErrorMessages("visitDate");
            const visitStartTimeError = extractErrorMessages("visitStartTime");
            const visitEndTimeError = extractErrorMessages("visitEndTime");
            const appointmentErrors = errors.filter((error) => error.instancePath === `/${path}` && error.message);
            setVisitDateError(getAppointmentError(appointmentErrors, "visitDate", visitDateError));
            setVisitStartTimeError(getAppointmentError(appointmentErrors, "visitStartTime", visitStartTimeError, "validateTimeRange"));
            setVisitEndTimeError(getAppointmentError(appointmentErrors, "visitEndTime", visitEndTimeError, "validateTimeRange"));
            const futureAppointmentError = getOtherErrors("futureAppointment");
            const pastAppointmentError = getOtherErrors("pastAppointment");
            setExtraError(futureAppointmentError || pastAppointmentError);
        }
        else {
            setVisitDateError(undefined);
            setVisitStartTimeError(undefined);
            setVisitEndTimeError(undefined);
            setExtraError(undefined);
        }
    }, [errors]);
    return {
        visitDateError,
        visitStartTimeError,
        visitEndTimeError,
        extraError,
    };
};
exports.useAppointmentErrors = useAppointmentErrors;
